import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import { fetchQuotas } from "./api";
import type { QuotasResponse } from "./api";

// Org-scoped запрос (см. `src/query/scope.ts`). Polling каждые 2 сек —
// индикатор квот растёт «вживую» по мере того, как runner шлёт
// ReportUsage. 2с — достаточно плавно для UX, не нагружает backend на
// одну org.
const POLL_INTERVAL_MS = 2000;

export function useQuotas(): UseQueryResult<QuotasResponse, Error> {
  return useOrgScopedQuery<QuotasResponse>({
    key: ["quotas"],
    queryFn: () => fetchQuotas(),
    refetchInterval: POLL_INTERVAL_MS,
    retry: false,
  });
}
